<template>
    <v-container>
      <v-row>
        <v-col md="12" class="pa-6 text-left text-justify">
          <div class="my-6">
                    <p class="text-h4 text--primary">
                        <TextHeading :level=3>Przygotowywanie wniosków o dofinansowanie</TextHeading>
                    </p>
                    <div class="text-body-1 text--primary">
                      Szanujemy czas i pieniądze naszych Klientów, dlatego przed podjęciem współpracy w zakresie aplikowania o dofinansowanie przeprowadzamy bezpłatną analizę na podstawie której podejmowana jest decyzja o możliwym powodzeniu. To jest jeden z elementów naszego sukcesu i bardzo wysokiej skuteczności. 
                    </div>
                    <br />
                    <div class="text-body-1 text--primary">
                      Oferujemy naszym Klientom kompleksową obsługę w zakresie:
                    </div>
                    <v-list dense disabled>
                      <v-list-item
                        v-for="(item, i) in goals"
                        :key="i"
                      >
                        <v-list-item-icon>
                          <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-icon>

                        <v-list-item-title class="text-body-1 text--primary text-wrap font-weight-regular">{{ item.text }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                    <div class="text-body-1 text--primary">
                      Realizujemy projekty na terenie całego kraju - niektóre z naszych projektów znajdują się <router-link class="nav-link" to="/our_projects/prepare_funds">tu</router-link>. Jeżeli potrzebujecie się Państwo upewnić, czy Wasza Inwestycja / Wniosek / Projekt ma szanse powodzenia skorzystajcie z naszej bezpłatnej pomocy a decyzję o współpracy podejmiecie na podstawie jej wyników
                    </div>
                    <prepare-fund-applications-form />
          </div>
        </v-col>
      </v-row>
    </v-container>
  </template>
  <script>
  import TextHeading from "@/modules/TextHeading";
  import PrepareFundApplicationsForm from "@/modules/forms/PrepareFundApplicationsForm";
  export default {
    
    components: {TextHeading, PrepareFundApplicationsForm},

    data: () => ({
      goals: [
        {
          text: 'Przygotowania Biznes Planu / Studium Wykonalności;',
          icon: "mdi-circle-medium"
        },
        {
          text: 'Opracowania wniosku o dofinansowania;',
          icon: "mdi-circle-medium"
        },
        {
          text: 'Przygotowania analiz środowiskowych;',
          icon: "mdi-circle-medium"
        },
        {
          text: 'Stworzenia załączników dotyczących pomocy publicznej;',
          icon: "mdi-circle-medium"
        },
        {
          text: 'Przygotowania innych załączników wymaganych dla złożenia wniosku o dofinansowanie',
          icon: "mdi-circle-medium"
        },
      ],
    })
  }
  </script>